<template>
    <div>
        <Row :gutter="16">
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 60px">代理组:</span>
                    <Select v-model="table.params.platid" filterable placeholder="选择APP分组" clearable>
                        <Option v-for="(item, index) in select.platform_list" :value="item.value" :label="item.name" :key="index"
                            >{{ item.name }}
                            <span style="color: #bbb">({{ item.value }})</span>
                        </Option>
                    </Select>
                </label>
            </Col>
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 60px">代理:</span>
                    <Select clearable filterable placeholder="App包信息" v-model="table.params.app_id" @on-change="appchange">
                        <Option v-for="(item, index) in select.app_list" :value="item.value" :key="index" :label="item.name">
                            {{ item.name }}<span style="color: #bbb">（{{ item.value }}）</span>
                        </Option>
                    </Select>
                </label>
            </Col>
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 80px">游戏信息:</span>
                    <Select clearable filterable placeholder="游戏信息" v-model="table.params.game_id">
                        <Option v-for="(item, index) in select.game_list" :value="item.value" :key="index" :label="item.name"
                            >{{ item.name }}<span style="color: #bbb">（{{ item.value }}）</span></Option
                        >
                    </Select>
                </label>
            </Col>
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 80px">服务名称:</span>
                    <Select clearable filterable placeholder="服务名称" v-model="table.params.server_name">
                        <Option v-for="(item, index) in select.srv_list" :value="item.value" :key="index" :label="item.name"
                            >{{ item.name }}<span style="color: #bbb">（{{ item.value }}）</span></Option
                        >
                    </Select>
                </label>
            </Col>
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 80px">服务ID:</span>
                    <Input v-model="table.params.server_id" placeholder="搜索 服务ID" />
                </label>
            </Col>
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 80px">服务状态:</span>
                    <Select clearable filterable placeholder="服务状态" v-model="table.params.status">
                        <Option v-for="(item, index) in select.status_list" :value="item.value" :key="index" :label="item.name">{{ item.name }}</Option>
                    </Select>
                </label>
            </Col>
            
        </Row>
        <Row :gutter="16" style="margin-top: 12px">
            <Col span="4">
                <label style="display: flex; align-items: center">
                    <span style="width: 80px">服务标签:</span>
                    <Select clearable filterable placeholder="服务标签" v-model="table.params.tag">
                        <Option v-for="(item, index) in select.tag_list" :value="item.value" :key="index">{{ item.name }}</Option>
                    </Select>
                </label>
            </Col>
            <Col span="8">
                <Button type="primary" style="margin: 0 12px" @click="SearList">搜索</Button>
                <Button type="primary" style="margin-right: 12px" icon="md-refresh" @click="reloadSingle">刷新</Button>
                <Button type="primary" style="margin-right: 12px" @click="OpenModal1('add')">添加路由</Button>
            </Col>
        </Row>
        <Table border :ref="table.ref" :columns="table.columns" :data="table.data" style="margin-top: 12px" @on-selection-change="SelectRow" />
        <Page show-total show-sizer style="margin-top: 12px" :page-size="table.params.page_size" :total="table.page_total" :current="table.page_current" @on-change="ChangePage" @on-page-size-change="ChangePageSize" />
        <div style="margin-top: 12px">
            <Button class="bottom_btn" type="primary" @click="OpenModal3" :disabled="!table.sel_ids.length">批量修改</Button>
            <Button class="bottom_btn" type="primary" @click="OpenModal2" :disabled="!table.sel_ids.length">复制</Button>
            <Button class="bottom_btn" type="error" @click="Delete()" :disabled="!table.sel_ids.length">删除</Button>
        </div>

        <!-- 编辑 -->
        <Modal v-model="modal1.show" @on-cancel="CloseModal1" width="600">
            <div slot="header">{{ modal1.type == 'add' ? '新增' : '修改' }} 游戏详情</div>
            <Form :ref="modal1.form.ref" :model="modal1.form.data" :rules="modal1.form.rules" :label-width="120">
                <Row>
                    <Col span="20">
                        <FormItem label="App包信息" prop="app_id">
                            <Select clearable placeholder="请选择 App" v-model="modal1.form.data.app_id">
                                <Option v-for="(item, index) in select.app_list" :value="item.value" :key="index" :label="item.name">
                                    {{ item.name }}<span style="color: #bbb">（{{ item.value }}）</span>
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="游戏信息" prop="game_id">
                            <Select clearable placeholder="请选择 游戏" v-model="modal1.form.data.game_id" @on-change="ChangeGameID">
                                <Option v-for="(item, index) in select.game_list" :value="item.value" :key="index"
                                    >{{ item.name }}<span style="color: #bbb">（{{ item.value }}）</span></Option
                                >
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row v-if="modal1.form.data.game_id">
                    <Col span="20">
                        <FormItem label="房间选择">
                            <RadioGroup v-model="modal1.form.data.game_level">
                                <Radio v-for="(item, index) in modal1.form.select.room_list" :key="index" :label="item.level"
                                    >{{ item.name }}<span style="color: #bbb">({{ item.level }})</span></Radio
                                >
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="服务名称" class="mylabel" prop="server_name">
                            <InputSear :showName="true" v-model="modal1.form.data.server_name" :datalist="select.srv_list" placeholder="请选择 服务" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="服务ID" prop="server_id">
                            <Input placeholder="请输入 服务ID" v-model="modal1.form.data.server_id" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="服务状态">
                            <RadioGroup v-model="modal1.form.data.status">
                                <Radio label="0">禁用</Radio>
                                <Radio label="1">启用</Radio>
                                <Radio label="2">隐藏</Radio>
                                <Radio label="3">小黑屋</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="服务标签" class="mylabel">
                            <InputSear v-model="modal1.form.data.tag" :datalist="select.tag_list" placeholder="请填写 服务标签" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="专属UID" prop="Uid">
                            <Input placeholder="专属UID 如:1,2,5" v-model="modal1.form.data.uids"></Input>
                        </FormItem>
                    </Col>
                </Row>
            </Form>

            <div slot="footer">
                <Button type="primary" @click="Update">提交</Button>
            </div>
        </Modal>

        <!-- 复制 -->
        <Modal v-model="modal2.show" @on-cancel="CloseModal2" width="600">
            <div slot="header">批量复制</div>
            <Form :ref="modal2.form.ref" :model="modal2.form.data" :label-width="150">
                <Row>
                    <Col span="20">
                        <FormItem label="App" prop="app_id">
                            <Select clearable placeholder="请选择 App" v-model="modal2.form.data.app_id">
                                <Option v-for="(item, index) in select.app_list" :value="item.value" :key="index" :label="item.name">
                                    {{ item.name }}<span style="color: #bbb">（{{ item.value }}）</span>
                                </Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="CopyUpdate">保存</Button>
            </div>
        </Modal>

        <!-- 批量修改 -->
        <Modal v-model="modal3.show" @on-cancel="CloseModal3" width="600">
            <div slot="header">批量修改游戏路由配置</div>
            <Form :ref="modal3.form.ref" :model="modal3.form.data" :label-width="150">
                <Row>
                    <Col span="20">
                        <FormItem label="服务名字" prop="server_name">
                            <Select clearable placeholder="服务名称" v-model="modal3.form.data.server_name">
                                <Option v-for="(item, index) in select.srv_list" :value="item.value" :key="index">{{ item.name }}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="服务ID" prop="server_id">
                            <Input v-model="modal3.form.data.server_id" placeholder="服务ID" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="专属UID" prop="uids">
                            <Input v-model="modal3.form.data.uids" placeholder="专属UID 如:1,2,5" />
                        </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="20">
                        <FormItem label="状态" prop="status">
                            <RadioGroup v-model="modal3.form.data.status">
                                <Radio label="-1">不修改</Radio>
                                <Radio label="0">禁用</Radio>
                                <Radio label="1">启用</Radio>
                                <Radio label="2">隐藏</Radio>
                                <Radio label="3">小黑屋</Radio>
                            </RadioGroup>
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <Button type="primary" @click="BatchEdit">保存</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import { GetAllAppList, GetAllPlatform, TransTopReq, GetAllGameList } from '@/api/admin/risk'
import InputSear from '../components/InputSear.vue'
import GameRouteConfigMoreBtn from './components/GameRouteConfigMoreBtn.vue'
export default {
    name: 'GameRouteConfig',
    components: { InputSear },
    data() {
        return {
            select: {
                platform_list: [],
                app_list: [],
                game_list: [],
                srv_list: [],
                status_list: [
                    { value: 0, name: '禁用' },
                    { value: 1, name: '启用' },
                    { value: 2, name: '隐藏' },
                    { value: 3, name: '小黑屋' }
                ],
                tag_list: [],
                room_list: []
            },
            table: {
                ref: 'table',
                params: {
                    platid: 0,
                    app_id: -1,
                    game_id: 0,
                    server_name: '',
                    server_id: '',
                    tag: '',
                    status: -1,
                    page: 1,
                    page_size: 10
                },
                columns: [
                    { type: 'selection', key: 'id', fixed: 'left', width: 50, align: 'center', resizable: true },
                    {
                        title: 'App包信息',
                        minWidth: 130,
                        align: 'center',
                        resizable: true,
                        render: (h, params) => {
                            let app_info = this.select.app_list.find((item) => item['value'] == params.row.app_id) || { name: '' }
                            return h('div', [h('span', app_info.name), h('span', { style: 'color:#bbb;' }, `（${params.row.app_id}）`)])
                        }
                    },
                    {
                        title: '游戏信息',
                        minWidth: 150,
                        align: 'center',
                        resizable: true,
                        render: (h, params) => {
                            let game_info = this.select.game_list.find((item) => item['value'] == params.row.game_id)
                            if (game_info) {
                                return h('div', [h('span', game_info.name), h('span', { style: { color: '#BBB' } }, `（${game_info['value']}）`)])
                            } else {
                                return h('span', { style: { color: '#ed4014' } }, '未找到指定游戏')
                            }
                        }
                    },
                    {
                        title: '游戏房间 (level) (rule)',
                        minWidth: 180,
                        align: 'center',
                        resizable: true,
                        render: (h, params) => {
                            let game_list = this.select.game_list.filter((v) => v['value'] == params.row.game_id)[0]
                            let arr
                            if (game_list) {
                                arr = [h('span', game_list['name'])]
                                if (params.row.game_level == '*' && params.row.game_rule == '*') {
                                    arr.push(h('span', { style: { color: '#bbb' } }, `（全部）`))
                                } else {
                                    arr.push(h('span', { style: { color: '#bbb' } }, `（${params.row.game_level}）`), h('span', { style: { color: '#bbb' } }, `（${params.row.game_rule}）`))
                                }
                            }

                            return h('div', arr)
                        }
                    },
                    {
                        title: '服务名称',
                        minWidth: 140,
                        align: 'center',
                        resizable: true,
                        render: (h, params) => {
                            let srv_info = this.select.srv_list.filter((v) => v['value'] == params.row.server_name)[0]
                            let arr = []
                            if (srv_info) {
                                arr.push(h('span', srv_info['name']), h('span', { style: { color: '#bbb' } }, `（${srv_info['value']}）`))
                            }
                            return h('div', arr)
                        }
                    },
                    { title: '服务ID', key: 'server_id', minWidth: 140, align: 'center', resizable: true, sortable: true },
                    { title: '服务标签', key: 'tag', minWidth: 110, align: 'center', resizable: true, sortable: true },
                    { title: 'UIDS', key: 'uids', minWidth: 110, resizable: true, align: 'center' },
                    {
                        title: '状态',
                        width: 90,
                        align: 'center',
                        resizable: true,
                        render: (h, params) => h('span', { style: `color:${['#ed4014', '#19be6b', '#ababab', '#333'][params.row.status]}` }, ['禁用', '启用', '隐藏', '小黑屋'][params.row.status]),
                        filters: [
                            { value: 0, label: '禁用' },
                            { value: 1, label: '启用' }
                        ],
                        filterMultiple: false,
                        filterMethod(value, row) {
                            return row.status == value
                        }
                    },
                    {
                        fixed: 'right',
                        title: '管理',
                        align: 'center',
                        width: 240,
                        resizable: true,
                        render: (h, params) => {
                            return h('div', [
                                h(
                                    'Button',
                                    {
                                        props: { type: 'primary' },
                                        style: { marginRight: '5px' },
                                        on: {
                                            click: () => {
                                                this.OpenModal1('edit', params.row)
                                            }
                                        }
                                    },
                                    '编辑'
                                ),
                                h(GameRouteConfigMoreBtn, {
                                    props: {
                                        id: params.row.id,
                                        platid: this.table.params.platid,
                                        app_id: this.table.params.app_id
                                    },
                                    style: { marginRight: '5px' },
                                    on: {
                                        getGameServerRouteList: this.GetList
                                    }
                                }),
                                h(
                                    'Button',
                                    {
                                        props: { type: 'error' },
                                        on: {
                                            click: () => {
                                                this.$Modal.confirm({
                                                    title: '确认删除',
                                                    onOk: () => {
                                                        this.Delete(params.row.id)
                                                    }
                                                })
                                            }
                                        }
                                    },
                                    '删除'
                                )
                            ])
                        }
                    }
                ],
                data: [],
                page_total: 1,
                page_current: 1,
                sel_ids: []
            },
            modal1: {
                show: false,
                type: 'add',
                form: {
                    ref: 'modal1_form',
                    select: {
                        room_list: new Array()
                    },
                    data: {},
                    rules: {
                        app_id: [
                            {
                                required: true,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (isNaN(Number(value))) {
                                        callback(new Error('请选择 App'))
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        ],
                        game_id: [
                            {
                                required: true,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (!value) {
                                        callback(new Error('请选择 游戏'))
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        ],
                        server_name: [
                            {
                                required: true,
                                trigger: 'change',
                                validator: (rule, value, callback) => {
                                    if (!value) {
                                        callback(new Error('请选择 服务'))
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        ],
                        server_id: [
                            {
                                required: true,
                                trigger: 'blur',
                                message: '请输入 服务ID',
                                validator: (rule, value, callback) => {
                                    if (!value) {
                                        callback(new Error('请输入 服务ID'))
                                    } else {
                                        callback()
                                    }
                                }
                            }
                        ]
                    }
                }
            },
            modal2: {
                show: false,
                form: {
                    ref: 'modal2_form',
                    data: {}
                }
            },
            modal3: {
                show: false,
                form: {
                    ref: 'modal3_form',
                    data: {
                        status: -1
                    }
                }
            }
        }
    },
    methods: {
        reloadSingle() {
            this.GetPlatform()
            this.GetGameList()
            this.GetGameRoomInfoList()
            this.GetSrvGameTagList()
            this.GetSrvNameList()
        },
        GetPlatform() {
            GetAllPlatform({}).then((res) => {
                let data = res._param.data || []
                let nlist = []
                data.map((item) => {
                    nlist.push({
                        value: item.id || 0,
                        name: item.name
                    })
                })
                this.select.platform_list = nlist
                this.table.params.platid = this.select.platform_list[0]['value']
                this.GetAppList()
            })
        },
        GetAppList() {
            let param = {
                page: 1,
                page_size: 10000
            }
            GetAllAppList(param).then((res) => {
                let data = res._param.List || []
                let nlist = []
                let arr = []
                data.map((item) => {
                    nlist.push({
                        value: item.appid || 0,
                        name: item.appName,
                        platform: item.platform
                    })
                })
                this.select.app_list = nlist
                this.table.params.app_id = nlist.filter((item) => item.platform == this.table.params.platid)[0]['value']
                this.GetGameRoomInfoList()
                this.GetSrvGameTagList()
                this.GetSrvNameList()
                this.GetList()
            })
        },
        GetGameList() {
            return new Promise((resolve, reject) => {
                let param = {
                    gtype: 0,
                    page: 1,
                    page_size: 10000
                }
                GetAllGameList(param).then((res) => {
                    let data = res._param.data
                    let nlist = []

                    data.map((item) => {
                        nlist.push({
                            value: item.game_id,
                            name: item.game_name
                        })
                    })
                    this.select.game_list = nlist
                    resolve(true)
                })
            })
        },
        GetGameRoomInfoList() {
            TransTopReq(this.returnParam('GetGameRoomInfo', {})).then((res) => {
                let data = res._param.data
                let nlist = []
                data.map((item) => {
                    nlist.push({
                        game_id: item.game_id,
                        name: item.name,
                        level: item.level,
                        rule: item.rule
                    })
                })
                this.select.room_list = nlist
            })
        },
        GetSrvGameTagList() {
            TransTopReq(this.returnParam('GetSrvGameTag', {})).then((res) => {
                let data = res._param.tags || []
                let nlist = []
                data.map((item) => {
                    nlist.push({
                        value: item,
                        name: item
                    })
                })
                this.select.tag_list = nlist
            })
        },
        GetSrvNameList() {
            TransTopReq(this.returnParam('GetSrvNameList', {})).then((res) => {
                let data = res._param.data || []
                let nlist = []
                data.map((item) => {
                    nlist.push({
                        value: item.srv_name,
                        name: item.name
                    })
                })
                this.select.srv_list = nlist
            })
        },
        appchange() {
            this.GetSrvNameList()
        },
        SelectRow(selection) {
            this.table.sel_ids = []
            selection.map((item) => {
                this.table.sel_ids.push(item.id)
            })
        },
        GetList() {
            let params = { ...this.table.params }
            params.status = params.status == undefined ? -1 : params.status
            params.app_id = params.app_id == undefined ? -1 : params.app_id
            params.server_id = Number(params.server_id)
            TransTopReq(this.returnParam('GetGameServerRouteList', params)).then((res) => {
                let data = res._param
                this.table.data = data.data || []
                this.table.page_total = data.total
            })
        },
        ChangePage(page) {
            this.table.params.page = page
            this.table.page_current = page
            this.table['sel_data'] = []
            this.GetList()
        },
        ChangePageSize(page_size) {
            this.table.params.page = 1
            this.table.page_current = 1
            this.table.params.page_size = page_size
            this.table['sel_data'] = []
            this.GetList()
        },
        SearList() {
            this.table.params.page = 1
            this.$refs[this.table.ref].currentPage = 1
            this.table.page_current = 1
            this.GetList()
        },
        Delete(id) {
            if (id) {
                let params = {
                    action: 2,
                    ids: [id]
                }
                TransTopReq(this.returnParam('BatchGameServerRoute', params)).then((res) => {
                    this.GetList()
                })
            } else {
                let data_list = this.table.sel_ids
                let params = {
                    action: 2,
                    ids: data_list
                }
                this.$Modal.confirm({
                    title: '确认删除',
                    content: `确认删除 <span style="color:red">${data_list.length}</span> 条记录`,
                    onOk: () => {
                        TransTopReq(this.returnParam('BatchGameServerRoute', params)).then((res) => {
                            this.table.sel_ids = []
                            this.GetList()
                        })
                    }
                })
            }
        },
        OpenModal1(type, row = {}) {
            this.modal1.show = true
            this.modal1.type = type

            let ndata = {
                status: 1,
                uids: [],
                game_level: '*',
                ...row
            }
            ndata.status = ndata.status.toString()
            ndata.uids = ndata.uids.join(',')

            this.modal1.form.data = ndata
            this.ChangeGameID()
        },
        CloseModal1() {
            this.modal1.show = false
            this.$refs[this.modal1.form.ref].resetFields()
        },
        ChangeGameID() {
            let value = this.modal1.form.data['game_id']
            let room_list = [
                {
                    game_id: value,
                    name: '全部',
                    level: '*',
                    rule: '*'
                }
            ]
            let list = this.select.room_list.filter((v) => v['game_id'] == value)
            this.modal1.form.select.room_list = [...room_list, ...this.copyData(list)]
        },
        Update() {
            this.$refs[this.modal1.form.ref].validate((valid) => {
                if (valid) {
                    let params = {
                        id: 0,
                        ...this.modal1.form.data
                    }
                    params.game_rule = params.game_level == '*' ? '*' : this.select.room_list.filter((v) => v['game_id'] == params.game_id).filter((v) => v['level'] == params.game_level)[0]['rule']
                    params.status = Number(params.status)
                    params.server_id = Number(params.server_id)
                    params.uids = params.uids
                        ? params.uids
                              .split(',')
                              .filter((v) => v)
                              .map((item) => {
                                  return Number(item)
                              })
                        : []
                    delete params._index
                    delete params._rowKey
                    TransTopReq(this.returnParam('UpdateGameServerRouteList', params)).then((res) => {
                        this.CloseModal1()
                        this.GetList()
                        this.$Notice.success({
                            desc: '操作成功！'
                        })
                    })
                }
            })
        },
        OpenModal2() {
            this.modal2.show = true
        },
        CloseModal2() {
            this.modal2.show = false
            this.$refs[this.modal2.form.ref].resetFields()
        },
        CopyUpdate() {
            let params = {
                ids: this.table.sel_ids,
                app_id: this.modal2.form.data['app_id']
            }
            TransTopReq(this.returnParam('CopyGameRoute', params)).then((res) => {
                this.CloseModal2()
                this.GetList()
                this.$Notice.success({
                    desc: '操作成功！'
                })
            })
        },
        OpenModal3() {
            this.modal3.show = true
            // this.modal3.form.data['status'] = this.modal3.form.data.status.toString()
        },
        CloseModal3() {
            this.modal3.show = false
            this.$refs[this.modal3.form.ref].resetFields()
        },
        BatchEdit() {
            let params = {
                ids: this.table.sel_ids,
                ...this.modal3.form.data
            }
            params.server_id = params.server_id ? Number(params.server_id) : ''
            params.uids = params.uids
                ? params.uids
                      .split(',')
                      .filter((v) => v)
                      .map((item) => {
                          return Number(item)
                      })
                : ''
            params.status = Number(params.status)

            !params.server_id && delete params.server_id
            !params.uids && delete params.uids
            TransTopReq(this.returnParam('BatchUpdateGameRoute', params)).then((res) => {
                this.CloseModal3()
                this.GetList()
                this.$Notice.success({
                    desc: '操作成功！'
                })
            })
        },
        returnParam(func, param) {
            return {
                mod: 'root',
                platid: this.table.params.platid,
                app_id: this.table.params.app_id,
                param: {
                    _mod: 'root',
                    _func: func,
                    _param: {
                        ...param
                    }
                }
            }
        }
    },
    created() {
        this.GetPlatform()
        this.GetGameList()
    }
}
</script>

<style lang="less">
.mylabel label {
    position: absolute;
}
.bottom_btn {
    margin-right: 12px;
}
</style>
